 <template>
  <el-container>
    <el-main>
      <div class="messageFixedBox" @mouseleave="onLeaveMessage" @mouseenter="onenterMessage">
        <div class="leftDom" v-show="showMessageBox">
          <div class="messageTop">
            <div>
              <span :class="curTab == 1?'checked':''" @click="changeTab(1)">患者消息</span>
              <span :class="curTab == 2?'checked':''" @click="changeTab(2)">医生消息</span>
            </div>
            <div class="messageTop">
              <span>未处理:</span>
              <p class="messageTotal" :class="handleNum(total) !='99+'?'messageTotalLess':''">
                {{handleNum(total)}}</p>
            </div>
          </div>
          <!-- 患者 -->
          <div v-if="curTab == 1">
            <div v-if="patientWholeCourseCacheVOList.length>0">
              <div class="messageItem" :class="(patientWholeCourseCacheVOList.length >3 && index==2)?'line':''"
                v-for="(item,index) in  patientWholeCourseCacheVOList.slice(0,3)" :key="index"
                @click="toCaesePage(item)">
                <img class="userPhoto" v-if="item.photoUrl" :src="item.photoUrl" alt="">
                <img class="userPhoto" v-else src="../assets/images/headLogo.png" alt="">
                <div class="userMess">
                  <div style="display:flex">
                    <span>{{item.patientName}}</span>
                    <p v-if="item.diseaseName||item.firstTherapyStageName"><span
                        v-if="item.diseaseName">{{item.diseaseName}}</span> <span
                        v-if="item.firstTherapyStageName">-{{item.firstTherapyStageName}}</span> </p>
                  </div>
                  <div class="description" v-html="replaceEmoji(item.localBody)"></div>
                </div>
              </div>
              <img class="foldBox" v-show="patientWholeCourseCacheVOList.length>3" src="../assets/images/border.png"
                alt="">
            </div>
            <div class="noMessage" v-else>
              <img src="../assets/images/nomessage.png" alt="">
              <p>消息全部回复完成，辛苦啦！</p>
            </div>
          </div>
          <!-- 医生 -->
          <div v-else>
            <div v-if="doctorNursingCacheVOList.length>0">
              <div class="messageItem" :class="(doctorNursingCacheVOList.length >3 && index==2)?'line':''"
                v-for="(item,index) in  doctorNursingCacheVOList.slice(0,3)" :key="index" @click="toCaesePage(item)">
                <img class="userPhoto" v-if="item.fromAccountUrl" :src="item.fromAccountUrl" alt="">
                <img class="userPhoto" v-else src="../assets/images/headLogo.png" alt="">
                <div class="userMess">
                  <!-- 是异常指标 -->
                  <div style="display:flex" v-if="item.customMsgType === 2005">
                    <span>指标异常消息-{{ item.patientName }}</span>
                  </div>
                  <div style="display:flex" v-else>
                    <span>{{item.fromAccountName}}</span>
                    <p>
                      <span v-if="item.departmentAndTeam">{{item.departmentAndTeam}}</span>
                    </p>
                  </div>
                  <!-- 是异常指标 -->
                  <div class="description" v-html="replaceEmoji(item.localBody)"></div>
                </div>
              </div>
              <img class="foldBox" v-show="doctorNursingCacheVOList.length>3" src="../assets/images/border.png" alt="">
            </div>
            <div class="noMessage" v-else>
              <img src="../assets/images/nomessage.png" alt="">
              <p>消息全部回复完成，辛苦啦！</p>
            </div>
          </div>
        </div>

        <div class="rightDom" :class="!showMessageBox?'setMessageHeight':''">
          <div class="centerDom">
            <span>消</span>
            <span>息</span>
            <span>提</span>
            <span>醒</span>
          </div>
          <div class="centerDom">
            <i class="el-icon-message-solid" style="font-size:15px"></i>
            {{handleNum(total)}}
          </div>
        </div>
      </div>
      <div class="fixedBox" :class="num>15?'moreText':''">
        <div class="leftPlateForm" v-show="showLeftPlateForm">
          <el-input placeholder="请输入搜索内容" type="textarea" maxlength="30" v-model="keyword" @input="searchHosClick">
          </el-input>
          <el-scrollbar style="height:168px" wrap-style="overflow-x:hidden;">
            <ul>
              <li :class="curIndex == index?'curItem':''" v-for="(item,index) in $store.state.authList"
                @click="choosePlatform(item,index)" :key="item.id">{{item.orgName}}</li>
            </ul>
          </el-scrollbar>
        </div>
        <div class="rightPlatForm" @click="showLeftPlateForm=!showLeftPlateForm">
          <div class="hosSearch">
            <i class="el-icon-search"></i>
          </div>
          <div class="writingMode">
            <div v-for='(item,index) in nameArr' :key='index'>{{item}}</div>
          </div>
          <div v-if="false">
            <i class="el-icon-message-solid" style="font-size:15px"></i><br />
            {{handleNum($websocket.state.messageNumber)}}
          </div>
        </div>
      </div>
      <router-view />
    </el-main>
  </el-container>
</template>  
<script>
import { switchUser } from "@/api/acc.js";
export default {
  data() {
    return {
      curTab: 2,
      roomLevel: 1,
      patientWholeCourseCacheVOList: [],
      doctorNursingCacheVOList: [],
      total: 0,
      showMessageBox: true,
      keyword: "",
      messageNum: 0,
      num: 0,
      authList: [],
      curObj: {},
      curIndex: null,
      showLeftPlateForm: false,
      nameArr: [],
      emojiList: this.$commen.emojiList,
      doctorImg: process.env.VUE_APP_OSS_URL //医生历史图片接受路径
    };
  },
  watch: {
    "$store.state.authList"(end) {
      end.map((item, index) => {
        if (item.isChecked) {
          this.curObj = item;
          if (item.searchFlag) {
            this.sliceContant(item.orgName);
          }
          this.curIndex = index;
          // if (!localStorage.getItem("userPlatForm")) {
          let info = this.getUserPlatForm(item);
          this.$store.commit("SET_PLATFORM", info);
          this.$store.commit("SET_PLATFORMINFO", item);
          // }
        }
      });
    },
    "$websocket.state.showMessageBox": {
      handler(val) {
        let end = this.$websocket.state.messageObj;
        this.patientWholeCourseCacheVOList =
          end.result && end.result.data
            ? end.result.data.patientWholeCourseCacheVOList
            : [];
        this.doctorNursingCacheVOList =
          end.result && end.result.data
            ? end.result.data.doctorNursingCacheVOList
            : [];
        this.roomLevel = end.result && end.result.data
            ? end.result.data.roomLevel
            : 1;
        this.total = end.result && end.result.data ? end.result.data.total : 0;
        if (end.result && end.result.data && end.result.data.roomLevel === 4) {
          // 医生消息
          this.curTab = 2;
        } else {
          // 患者消息
          this.curTab = 1;
        }
        if (
          (!end.noShowMessageBox &&
            this.patientWholeCourseCacheVOList.length > 0) ||
          (!end.noShowMessageBox && this.doctorNursingCacheVOList.length > 0)
        ) {
          this.showMessageBox = true;
        }
        setTimeout(() => {
          this.showMessageBox = false;
        }, 3000);
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.$store.dispatch("getUserAuthList", {
      key: this.keyword,
      search: true
    });
  },
  mounted() {},
  methods: {
    changeTab(val) {
      this.curTab = val;
    },
    //替换表情符号为图片
    replaceEmoji(str) {
      if (
        str == "[卡片消息]" ||
        str == "[图片]" ||
        str == "[语音]" ||
        str == "[文件]" ||
        str == "[视频]" ||
        str == "[消息已撤回]"
      ) {
        return str;
      }
      let replacedStr = str.replace(/\[([^(\]|\[)]*)\]/g, (item, index) => {
        for (let i = 0; i < this.emojiList.length; i++) {
          let row = this.emojiList[i];
          if (row.alt == item) {
            let onlinePath = this.doctorImg + "face/" + row.url;
            let imgstr =
              '<img style="width:25px;height:25px;vertical-align: middle;" src="' +
              onlinePath +
              '">';
            return imgstr;
          }
        }
      });
      return replacedStr;
    },
    toCaesePage(item) {
      this.showMessageBox = false;
      console.log("params", item);
      let params = {
        patientId: item.patientId,
        groupCode: item.groupCode,
        wholeCourseId: item.wholeCourseId,
        customerService: item.customerService,
        caseGroupRoomId: item.caseGroupRoomId,
        roomLevel: item.roomLevel // roomLevel为4为医护房间
      };
      if (
        this.$route.name == "customerRoom" ||
        this.$route.name == "IntoTheCase"
      ) {
        this.$store.commit("SEARCH_PATIENT", params);
      } else {
        let name = "IntoTheCase";
        if (item.customerService) {
          //客服消息
          name = "customerRoom";
        }
        this.$router.push({
          name: name,
          params: params
        });
      }
    },
    onLeaveMessage() {
      this.showMessageBox = false;
      this.curTab = 1;
    },
    onenterMessage() {
      this.showMessageBox = true;
      if (this.roomLevel === 4) {
          // 医生消息
          this.curTab = 2;
        } else {
          // 患者消息
          this.curTab = 1;
        }
    },
    searchHosClick(val) {
      this.num = val.length;
      this.$store.dispatch("getUserAuthList", {
        key: this.keyword,
        search: false
      });
    },
    handleNum(a, b) {
      // if (Number(a) + Number(b) > 99) {
      //   return "99+";
      // } else {
      //   return Number(a) + Number(b);
      // }
      if (Number(a) > 99) {
        return "99+";
      } else {
        return Number(a);
      }
    },
    sliceContant(name) {
      if (name) {
        let end = name.replace(/\s/g, "");
        this.nameArr = end.slice(0, 7).split("");
      }
    },
    choosePlatform(item, index) {
      this.curIndex = index;
      this.setUserAuthList(item);
    },
    //切换平台|| 机构
    setUserAuthList(obj) {
      let params = {
        companyId: obj.companyId, //平台id
        hospitalId: obj.hospitalId, //线下机构id
        platformId: obj.platformId, //互医机构id
        userState: obj.userState
      };
      switchUser(params).then(res => {
        if (res.code == 0 && res.data) {
          params.orgName = obj.orgName;
          params.imageUrl = obj.imageUrl;
          params.indexUrl = obj.indexUrl;
          this.curObj = obj;
          this.sliceContant(obj.orgName);
          let info = this.getUserPlatForm(params);
          this.$store.commit("SET_PLATFORMINFO", params);
          this.$store.commit("SET_PLATFORM", info);
          this.$store.dispatch("getMenuList");
          // this.$store.commit("GET_TOKEN", localStorage.getItem("socketToken"));
          if (this.$route.path != "/home") {
            this.$router.push({
              name: "home",
              params: {
                isRefresh: true
              }
            });
          } else {
            location.reload();
          }
        }
      });
    },
    getUserPlatForm(obj) {
      //平台
      if (obj.hospitalId == null && obj.platformId == null) {
        return "platForm";
      } else {
        return "organization";
      }
    }
  }
};
</script>
<style lang="less" scoped>
.messageFixedBox {
  position: fixed;
  top: 157px;
  right: 0;
  z-index: 9999;
  max-height: 299px;
  cursor: pointer;
  box-shadow: 0px 2px 4px 0px rgba(219, 220, 222, 0.2);
  display: flex;
  .leftDom {
    width: 416px;
    padding: 0 8px 5px;
    background: #eef5ff;
  }
  .rightDom {
    width: 24px;
    padding: 10px 0;
    background: #d0e4ff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
    color: #1a7bfc;
    line-height: 18px;
  }
  .setMessageHeight {
    height: 160px;
  }
  .centerDom {
    display: flex;
    flex-direction: column;
  }
  .messageTop {
    display: flex;
    justify-content: space-between;
    height: 38px;
    line-height: 38px;
    font-weight: bold;
    font-size: 14px;
    color: #383838;
    span {
      margin-right: 16px;
    }
    .checked {
      color: #1a7bfc;
    }
  }
  .messageTotal {
    width: 38px;
    height: 20px;
    color: #fff;
    background: #f63d3d;
    border-radius: 10px;
    margin-left: 10px;
    margin-top: 9px;
    line-height: 20px;
    text-align: center;
    font-weight: normal;
    font-size: 13px;
  }
  .messageTotalLess {
    width: 20px;
    border-radius: 50%;
  }
  .messageItem {
    background: #fff;
    height: 68px;
    padding: 0 12px 0 18px;
    border-radius: 4px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    .userPhoto {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .userMess {
      span {
        font-size: 14px;
      }
      p {
        padding: 0 8px;
        height: 20px;
        background: #eef5ff;
        border-radius: 10px;
        display: inline-block;
        line-height: 20px;
        color: #1a7bfc;
        margin-left: 15px;
        max-width: 250px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .description {
        width: 328px;
        margin-top: 5px;
        line-height: 25px;
        height: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .line {
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
    margin-bottom: 0;
  }
  .foldBox {
    width: 386px;
    position: relative;
    margin-left: 7px;
  }
  .noMessage {
    img {
      width: 159px;
      margin: 30px auto 0;
      display: block;
    }
    p {
      position: absolute;
      color: #97afd0;
      left: 140px;
      bottom: 48px;
    }
  }
}
.fixedBox {
  height: 196px;
  position: fixed;
  right: 0;
  color: #1a7bfc;
  top: 467px;
  z-index: 9999;
  overflow: hidden;
  cursor: pointer;
  .leftPlateForm {
    float: left;
    width: 240px;
    background: #eef5ff;
    color: #1a7bfc;
    box-shadow: 0px 2px 4px 0px rgba(219, 220, 222, 0.2);
    /deep/.el-textarea__inner {
      padding: 0 20px;
      background: #eef5ff;
      border: none;
      height: 28px;
      font-size: 12px;
      line-height: 28px;
      box-shadow: 0px 2px 4px 0px rgba(219, 220, 222, 0.2);
      resize: none;
      outline: none;
      border: none;
      overflow: hidden;
    }
    ul {
      padding: 15px 20px;
    }
    li {
      margin-bottom: 16px;
    }
    .curItem {
      font-weight: bold;
    }
  }
  .rightPlatForm {
    width: 24px;
    user-select: none;
    text-align: center;
    float: right;
    background: #d0e4ff;
    padding: 0 0 10px;
    .hosSearch {
      background: #1a7bfc;
      text-align: center;
      line-height: 28px;
      height: 28px;
      color: #fff;
      font-size: 18px;
      margin-bottom: 15px;
    }
  }
  .writingMode {
    padding: 0 4px;
    height: 112px;
    line-height: 18px;
    overflow: hidden;
    font-size: 14px;
    word-wrap: break-word;
  }
}
.fixedBox.moreText {
  /deep/.el-textarea__inner {
    padding-top: 7px;
    line-height: 16px;
    height: 46px;
  }
}
.fixedBox.moreText {
  height: 214px;
}
.moreText .rightPlatForm .hosSearch {
  height: 46px;
  line-height: 46px;
}
.el-main {
  background: #f8f8f8;
  padding: 0;
}
/deep/.el-header {
  padding-top: 15px;
  text-align: right;
}
</style>